import { Container } from '../../../odie';

import { MiniFuguBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-------------------------------------------------------------------------
const manifest = {
  image: 'fugu/block.fugu.2.png',
  fx: 'fx.hive/',
};

/*
    mini fugu block view
*/
export class MiniFuguBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: MiniFuguBlockProps) {
    // create base view
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }
}
